import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class StructuredStorageReduceBaseHelper extends StructuredStorageBaseHelper {
    constructor({ each, ...rest }) {
        super(rest);
        this.each = each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, options, sb.helpers.createIteratorStructuredStorage({ type: this.type }));
        sb.emitOp(node, 'SWAP');
        sb.emitHelper(node, optionsIn, sb.helpers.rawIteratorReduceBase({ each: this.each }));
    }
}

//# sourceMappingURL=StructuredStorageReduceBaseHelper.js.map
